import {Component, inject, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {FrontendService} from '../../../../services/frontend.service';
import {LoadingService} from '../../../../services/loading.service';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {ErrorType} from '../../../../model/error-type';
import {Match} from '../../../../model/events/Match';
import {EMessageType, MessageComponent} from '../../../../components/generic/message/message.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LoadingComponent} from '../../../../components/generic/loading/loading.component';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {DurationPipe} from '../../../../pipes/duration.pipe';
import {TooltipModule} from 'primeng/tooltip';
import {Button} from 'primeng/button';
import {AveragePipe} from '../../../../pipes/average.pipe';
import {CheckoutPipe} from '../../../../pipes/checkout.pipe';
import {MatchHelper} from '../../../../helper/match.helper';

@Component({
  standalone: true,
  selector: 'app-statistic-match-details',
  templateUrl: './statistic-match-details.component.html',
  styleUrls: ['./statistic-match-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    LoadingComponent,
    MessageComponent,
    TranslateModule,
    DatePipe,
    DurationPipe,
    TooltipModule,
    AveragePipe,
    NgForOf,
    NgIf,
    CheckoutPipe,
    Button
  ],
  animations: [
    trigger('flyInOutVertical', [
      state('in', style({transform: 'translateY(0)'})),
      transition('void => *', [
        style({transform: 'translateY(-100%)'}),
        animate(150)
      ]),
      transition('* => void', [
        animate(150, style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class StatisticMatchDetailsComponent implements OnInit
{
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);
  public frontendService = inject(FrontendService);

  loading = new LoadingService();
  errorMsg: ErrorType;
  isAdmin: boolean;

  match: Match;
  eventId: number;
  matchId: number;
  databaseId: number;

  statistic: any;
  statistics: any[];
  statisticsSinglePlayers: any[];

  statisticMatchList: any[];
  statisticMatchListSinglePlayers: any[];
  statisticLegList: any[][];
  statisticLegListSinglePlayers: any[][];
  setList: any[];
  statisticsCalculated: boolean;

  playernumber: string;
  dialogData: string;

  scoringDetails = false;
  anyScorePlus = false;
  anyBullShootout = false;
  checkoutRate = false;
  individualPlayersAvgDetails = false;
  individualPlayersAvgPerLegDetails = false;

  public static showDialog(dialogService: DialogService, match: Match, eventId: number, databaseId: number): void
  {
    console.log('showDialog, databaseId: ' + databaseId, match);
    const width = 800;

    dialogService.open(
      StatisticMatchDetailsComponent,
      {
        header: MatchHelper.getTitle(match),
        width: (window.screen.width < width) ? '90%' : (width + 'px'),
        dismissableMask: true,
        closable: true,
        modal: true,
        data: {
          match,
          eventId,
          matchId: match.id,
          databaseId
        }
      });
  }

  constructor()
  {
    console.log('constructor, config.data', this.config.data);  // Wird auch vom Dialog darüber übertragen
    this.eventId = this.config.data.eventId;
    this.databaseId = this.config.data.databaseId;
    this.matchId = this.config.data.matchId;
    this.match = this.config.data.match;
    if (this.match.eventId)
      this.eventId = this.match.eventId;
    if (this.match.id)
      this.matchId = this.match.id;

    console.log('eventId: ' + this.eventId + ', matchId: ' + this.matchId + ', databaseId: ' + this.databaseId);
    const event = this.match.event;
    console.log('Event: ', event);
  }

  ngOnInit(): void
  {
    this.loadData();
  }

  private loadData(): void
  {
    if (!this.match.isDartsscorer)
      return;

    this.loading.isLoading = true;
    this.errorMsg = undefined;
    this.statisticsCalculated = false;

    this.frontendService.getMatchStatistics(this.databaseId, this.eventId, this.matchId, false).subscribe({
      next: data =>
      {
        console.log('Match-Statistiken erhalten', data);
        if (data)
        {
          this.statistics = data.statistics;
          this.statisticsSinglePlayers = data.statisticsSinglePlayers;
        }
        this.calculateStatistics();
        this.loading.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.statistics = undefined;
        this.loading.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private calculateStatistics(): void
  {
    this.statisticMatchList = [];
    this.statisticMatchListSinglePlayers = [];
    this.statisticLegList = [];
    this.statisticLegListSinglePlayers = [];
    this.setList = [];

    try
    {
      let countPlayersPerParticipant = 1;
      let countPlayersPerParticipant3KDartsScorer = 1;
      if (this.statisticsSinglePlayers?.length > 0)
      {
        // Beim 3K Darts Scorer werden bei Doppeln die kumulierten Statistiken bereits übertragen
        for (const statistic of this.statisticsSinglePlayers)
        {
          if (statistic.playerPosition > 0 && statistic.playerPosition >= countPlayersPerParticipant3KDartsScorer)
            countPlayersPerParticipant3KDartsScorer = statistic.playerPosition + 1;

          this.calculateStatisticsSinglePlayers(statistic);
        }
      }

      for (const statistic of this.statistics)
      {
        if (statistic.playerPosition > 0 && statistic.playerPosition >= countPlayersPerParticipant)
          countPlayersPerParticipant = statistic.playerPosition + 1;

        this.calculateStatisticsMatch(statistic);
      }
      this.statisticMatchList.sort(this.sortByPlayer);

      console.log('countPlayersPerParticipant: ' + countPlayersPerParticipant + ', Anzahl Statistiken: ' +
        this.statisticMatchList.length);
      for (const statisticMatch of this.statisticMatchList)
        this.statisticLegList.push([]);

      this.anyBullShootout = false;
      for (const statistic of this.statistics)
      {
        if (statistic.type === 'LEG')
        {
          // console.log('statistic.type === \'LEG\', setIndex: ' + statistic.setIndex);
          const index = (countPlayersPerParticipant * statistic.playerIndex) + statistic.playerPosition;
          if (index >= 0 && index < this.statisticLegList.length)
            this.statisticLegList[index].push(statistic);
          else
          {
            console.error('Index außerhalb des Bereichs, Index: ' + index + ', statisticLegList.length: ' + this.statisticLegList.length);
            this.setErrorMsg(this.translate.instant('STATISTICS_CALCULATE_PROBLEM'));
          }

          if (statistic.playerIndex === 0 && statistic.setIndex >= 0)
          {
            if (!this.setList || this.setList.length === 0 || this.setList[this.setList.length - 1].set !== statistic.setIndex)
            {
              this.setList.push(
                {
                  set: statistic.setIndex,
                  numberOfLegs: 1
                }
              );
            }
            else
            {
              this.setList[this.setList.length - 1].numberOfLegs++;
            }
          }
          if (statistic.won && statistic.scoreTotal !== statistic.startPoints)
            this.anyBullShootout = true;
        }
      }

      if (this.statisticsSinglePlayers?.length > 0)
      {
        for (const statisticMatch of this.statisticMatchListSinglePlayers)
          this.statisticLegListSinglePlayers.push([]);

        for (const statistic of this.statisticsSinglePlayers)
        {
          if (statistic.type === 'LEG')
          {
            const index = (countPlayersPerParticipant3KDartsScorer * statistic.playerIndex) + statistic.playerPosition;
            if (index >= 0 && index < this.statisticLegListSinglePlayers.length)
              this.statisticLegListSinglePlayers[index].push(statistic);
          }
        }
      }
    }
    catch (ex: any)
    {
      console.error('Fehler:', ex);
      this.setErrorMsg(this.translate.instant('STATISTICS_CALCULATE_PROBLEM') + ' ' + ex);
    }
    console.log('statisticMatchList: ', this.statisticMatchList);
    console.log('statisticMatchListSinglePlayers: ', this.statisticMatchListSinglePlayers);
    console.log('statisticLegList: ', this.statisticLegList);
    console.log('statisticLegListSinglePlayers: ', this.statisticLegListSinglePlayers);
    if (this.statisticLegList?.length > 0 && this.statisticLegList[0].length > 0)
      this.statisticsCalculated = true;
  }

  private calculateStatisticsMatch(statistic: any): void
  {
    if (statistic.type === 'MATCH')
    {
      if (statistic.playerIndex === 0 && !statistic.playerPosition)
        this.statistic = statistic;

      this.statisticMatchList.push(statistic);
      // console.log('check stats for player 1, this.playernumber: ' + this.playernumber + ', playerIndex: ' + statistic.playerIndex);

      if (statistic.playerPlayernumber === this.playernumber
        || (this.dialogData === 'ADMIN' && statistic.playerIndex === 0))
      {
        this.statistic = statistic;
      }

      if (!this.anyScorePlus && (statistic.count60 > 0 || statistic.count80 > 0 || statistic.count90 > 0 ||
        statistic.count100 > 0 || statistic.count130 > 0 || statistic.count140 > 0 || statistic.count170 > 0 ||
        statistic.count180 > 0))
      {
        this.anyScorePlus = true;
      }

      if (statistic.checkDarts > 0)
        this.checkoutRate = true;
    }
  }

  private calculateStatisticsSinglePlayers(statistic: any): void
  {
    if (statistic.type === 'MATCH')
    {
      this.statisticMatchListSinglePlayers.push(statistic);
    }
  }

  private setErrorMsg(message: string): void
  {
    this.errorMsg = new ErrorType();
    this.errorMsg.closable = true;
    this.errorMsg.message = message;
    this.errorMsg.severity = EMessageType.warn;
  }

  private sortByPlayer(a: any, b: any): number
  {
    // if (!a.playerIndex || !b.playerIndex)
    //  return 0;
    if (a.playerIndex > b.playerIndex)
      return 1;
    else if (a.playerIndex < b.playerIndex)
      return -1;
    else
    {
      if (a.playerPosition > b.playerPosition)
        return 1;
      else if (a.playerPosition < b.playerPosition)
        return -1;
      else return 0;
    }
  }

  public getPlayername(stat: any): string
  {
    if (stat)
    {
      if (stat.playerIndex === 0)
        return this.match.participantHome.displayName;
      else if (stat.playerIndex === 1)
        return this.match.participantGuest.displayName;
    }

    return '-';
  }
}
